import { formatCryptoCurrency } from '@basqet-dashboard/common/utils';
import PropTypes from 'prop-types';
import React from 'react';

import { Coin } from '../coin';

const WalletCard = ({ wallet, extra }) => {
  const {
    currency: { slug = '', name: currencyName = '', icon_url: iconUrl = '' },
    available_balance: balance = ''
  } = wallet;

  return (
    <div className="wallet">
      <div className="wallet__logo">
        <Coin slug={slug} icon_url={iconUrl} />
        <span className="wallet__logo--name">{currencyName}</span>
      </div>
      <p className="wallet__balance">
        {formatCryptoCurrency(balance)}
        <span className="wallet__symbol">{slug}</span>
      </p>
      {extra}
    </div>
  );
};

WalletCard.propTypes = {
  wallet: PropTypes.object,
  extra: PropTypes.node
};

export { WalletCard };
